module.exports = __webpack_public_path__ + "img/icon_rule_content_corner.24e1760f.png";